import React, {useState} from 'react';

import cs from 'classnames';

import {preparedImageUploader} from 'app/utils/fineuploader';
import {gt} from 'app/utils/i18n';

import {FineUploaderArea} from '../FineUploaderArea';

import type {NewlyAttachedImageOrVideoType} from 'app/general/types';
import type {S3UploadConfigType} from 'sweet-types';
type Props = {
  onAddImage: (image: NewlyAttachedImageOrVideoType) => void;
  onUploaderReady?: (uploader: {
    methods: {addFiles: ({blob: Blob, name: string}) => unknown};
  }) => unknown;
  buttonClassName: string;
  renderUploadList?: (component) => React.ReactNode;
};

export const FineImageUploaderArea = ({
  onAddImage,
  buttonClassName,
  onUploaderReady,
  renderUploadList = (component) => component,
}: Props) => {
  const [isProcessing, setIsProcessing] = useState<boolean>(false);

  function createImageUploader(
    opts: S3UploadConfigType,
    accountId: number,
    mediaURL: string,
    otherOptions?: Record<string, any>
  ) {
    const uploader = preparedImageUploader(
      opts,
      accountId,
      mediaURL,
      otherOptions
    );
    onUploaderReady?.(uploader);
    return uploader;
  }

  return (
    <FineUploaderArea
      uploaderFactory={createImageUploader}
      awsUploadProfile="IMAGES"
      onUploadStart={() => setIsProcessing(true)}
      onUploadComplete={(image_ref) => {
        setIsProcessing(false);
        return onAddImage({
          image_ref,
        });
      }}
      uploadListRender={renderUploadList}
    >
      {(FileInput, uploader) =>
        isProcessing ? (
          <div className="progress">
            <div className="px-1 progress-bar progress-bar-striped progress-bar-animated w-100">
              {gt('Uploading Image...')}
            </div>
          </div>
        ) : (
          <div className="qq-uploader d-flex flex-column">
            <div className="drop lead">
              <i className="fa fa-cloud-upload-alt mr-1" aria-hidden="true" />
              {gt('Drag & drop images here')}
            </div>
            <FileInput multiple={false} accept="image/*" uploader={uploader}>
              <div className="qq-upload-button">
                <div className="qq-upload-button">
                  <button className={cs('btn btn-sm', buttonClassName)}>
                    {gt('Or browse your computer')}
                  </button>
                </div>
              </div>
            </FileInput>
          </div>
        )
      }
    </FineUploaderArea>
  );
};
